import signalr from '@/f1/service/signalr';

let resolveMap = {};
const rv = {
  status(key) {
    return new Promise((resolve, reject) => {
      resolveMap[key] = { resolve, reject };
      setTimeout(() => { resolveMap[key] ? resolve({ error : true, reason : 'Timeout' }) : '' }, 5000)
      return signalr.socket() && signalr.socket().invoke('wmds', { target : 'agent', cmd: 'status', body : { task_key : key } , app_id : 'wmds'});
    });
  },
  detail(key) {
    return new Promise((resolve, reject) => {
      resolveMap[key] = { resolve, reject };
      setTimeout(() => { resolveMap[key] ? resolve({ error : true, reason : 'Timeout' }) : '' }, 5000)
      return signalr.socket() && signalr.socket().invoke('wmds', { target : 'agent', cmd: 'detail', body : { task_key : key } , app_id : 'wmds'});
    });
  },
  stop(key) {
    return new Promise((resolve, reject) => {
      resolveMap[key] = { resolve, reject };
      // setTimeout(() => reject({ error : true, reason : 'Timeout' }), 3000)
      return signalr.socket() && signalr.socket().invoke('wmds', { target : 'agent', cmd: 'stop', body : { task_key : key } , app_id : 'wmds'});
    });
  }
}

signalr.subscribe('wmds', (m) => {
  let key = ''
  try {
    if(!m || m.error) { console.log("result null or error", m.reason); return;}
    let data = JSON.parse(m)
    if(!data) { return; }
    if(['status', 'detail', 'wmds', 'stop'].indexOf(data.type) > -1) {

      if(!(data.pl == undefined || !data.pl.task_key)) {
        key = data.pl.task_key;
        if(resolveMap[key]) { resolveMap[key].resolve(data); console.log("info from", key) }
      }
      delete resolveMap[key];
    }
  } catch (e) { console.log(e); delete resolveMap[key]; resolveMap[key].reject() }
});

export default rv;
